import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { BracketRound, TTournamentParams } from '~/../api/common.types';
import Section from '~/components/hero/LandingPage/Section';
import MainNav from '~/components/navbar/MainNav';
import { generateRoundsLogic, isBigBracket, isFinalsBracket, isSmallBracket, MatchupNavigation } from '~/components/tournament/matchups/MatchupNavigation';
import Bracket from '~/components/war/tournament/Bracket';
import Matchup from '~/components/war/tournament/Matchup';
import MatchupWarrior from '~/components/war/tournament/MatchupWarrior';
import { TOURNAMENTS } from '~/constants';
import { useGetContexts } from '~/hooks/game/useGetContexts';
import { useGetResultsOrPairings } from '~/hooks/game/useGetResultsOrPairings';
import { useGetOwnedNFTs } from '~/hooks/useGetOwnedNFTs';
import { useGetAccount } from '~/hooks/web3/useGetAccount';
import { getTournamentWinner } from '~/utils/utils';

const BracketComp = (
  { tournamentParam, battleIds }:
  {tournamentParam: TTournamentParams, battleIds: number[]}) => {
  const { data: matchupsByRound } = useGetResultsOrPairings({
    data: {
      contextId: TOURNAMENTS[tournamentParam].apiContext,
      rounds: battleIds,

    },
    enabled: true,
  });
  //   const matchupsByRound = undefined;
  const rounds = matchupsByRound ? generateRoundsLogic(matchupsByRound) : [];
  const [activeRound, setActiveRound] = useState<BracketRound | undefined>(undefined);

  useEffect(() => {
    if (rounds.length) {
      setActiveRound(rounds[rounds.length - 1]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rounds.length]);

  const { data: account } = useGetAccount();
  const { data: ownedWarriorRankings } = useGetOwnedNFTs({
    address: account?.address,
  });
  const ownedWarriorIDs = ownedWarriorRankings?.map(
    (warrior) => warrior.warrior_id
  );

  const finalsRound = matchupsByRound?.find((matchupsByRound) => isFinalsBracket(matchupsByRound) && matchupsByRound.round !== 0);
  let tournamentWinner;
  if (finalsRound) {
    tournamentWinner = getTournamentWinner(finalsRound);
  }

  return (
    <>
      {/* if want winner gif, uncomment */}
      {/* <div className={`container container--landing-page${activeRound?.bracketType === 'grid' ? ' container--landing-page-tournament' : ''} ${tournamentWinner ? ' container--landing-page-tournament-winner' : ''}`}> */}
      <div className={`container container--landing-page${activeRound?.bracketType === 'grid' ? ' container--landing-page-tournament' : ''}`}>
        <header className="landing-page__header">
          <MainNav showConnectWallet={true} />
        </header>
        <div
          className={`content-wrapper ${
            matchupsByRound && matchupsByRound.length ? '' : 'content-wrapper--small'
          } `}
        >
          <Section className="landing-page__section--champions">
            <header className="champions-header">
              <div className="champions-header__row">
                <div className="champions-header__section">
                  <h2 className="tourney-card__title">
                    {TOURNAMENTS[tournamentParam].name}
                  </h2>
                </div>
                <div className="champions-header__section--moonbird">
                  <h4>
                    <strong>Grand Prize</strong> → 0.5 ETH
                  </h4>
                  <img
                    src="/img/tournament/ethereum-eth.svg"
                    alt="Grand Prize: Moonbird"
                    width={194}
                  />
                </div>
                <div className="tournament-battles tournament-cta-wrapper">
                  <div className="image-stack">
                    <div className="image-stack__item image-stack__item--top">
                      <img
                        src="/img/warriors/upgrades/brawler/0.gif"
                        alt="Brawler"
                      />
                    </div>
                    <div className="image-stack__item image-stack__item--bottom">
                      <img
                        src="/img/warriors/upgrades/the-don/0.gif"
                        alt="The Don"
                      />
                    </div>
                  </div>
                  <p className="tournament-cta--text">
                    Have a Warrior in the tournament?
                    <br /> Enter your attacks here:
                  </p>
                  <Link
                    href={`/tournaments/battles/${tournamentParam}`}
                    passHref
                  >
                    <button className="button" type="button">
                      Enter attacks
                    </button>
                  </Link>
                </div>
              </div>
              <div className="champions-header__row champions-header__row--prizes">
                <div className="champions-header__section">
                  <div className="champion_places">
                    <div className="champion_place">
                      <h4>
                        <strong>2nd Place</strong> → 0.2 ETH
                      </h4>
                    </div>
                    <div className="champion_place">
                      <h4>
                        <strong>3rd-4th Place</strong> → 0.1 ETH
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="champions-header__section">
                  <div className="champion_places">
                    <div className="champion_place">
                      <h4>
                        <strong>5th-8th Place</strong> → 0.05 ETH
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </header>
          </Section>
          {rounds && Boolean(rounds.length) && activeRound && (
            <MatchupNavigation
              activeRound={activeRound}
              setActiveRound={setActiveRound}
              rounds={rounds}
              tournamentParam={tournamentParam}
            />
          )}
          {activeRound?.bracketType === 'bracket' && matchupsByRound && Boolean(matchupsByRound.length) && (
            <Bracket
              matchupsByRound={matchupsByRound.filter((matchupsByRound) => isBigBracket(matchupsByRound))}
              ownedWarriorIDs={ownedWarriorIDs}
            />
          )}

          {activeRound?.bracketType === 'final4' && matchupsByRound && Boolean(matchupsByRound.length) && (
            <Bracket
              matchupsByRound={matchupsByRound.filter((matchupsByRound) => isSmallBracket(matchupsByRound))}
              ownedWarriorIDs={ownedWarriorIDs}
            />
          )}
          {activeRound?.bracketType === 'finals' && finalsRound && (
            <>
              {tournamentWinner ?
                <div className="bracket__winner">
                  <p className="bracket__winner-title">{tournamentWinner.name} <span>Tournament</span> Winner</p>
                  <>
                    <MatchupWarrior
                      warrior={tournamentWinner}
                      active={true}
                      facing="west"
                    />
                  </>
                </div> :
                <Section className="landing-page__section--tournament_bracket landing-page__section--tournament_bracket--finals">
                  {finalsRound.matchups.map((matchup: any, i) => {
                    const [warriorOne, warriorTwo] = matchup;
                    return (<>
                      <div className={'bracket__matchup bracket__matchup--finals'} key={`${i}-${activeRound.battleId}-${warriorOne.id}-${warriorTwo.id}`}>
                        <Matchup
                          matchup={matchup}
                          ownedWarriorIDs={ownedWarriorIDs}
                          isBracket={false}
                          defaultActive={true}
                        />
                      </div>
                      <p className="bracket__explainer--finals">{warriorOne.name} vs {warriorTwo.name}</p>
                    </>);
                  })}
                </Section>
              }
            </>
          )}
          {activeRound?.bracketType === 'grid' && matchupsByRound && Boolean(matchupsByRound.length) && (
            <Section className="landing-page__section--champion-matchups">
              {matchupsByRound[activeRound.battleId].matchups.map((matchup: any, i) => {
                const [warriorOne, warriorTwo] = matchup;
                return (
                  <Matchup
                    matchup={matchup}
                    key={`${i}-${warriorOne.id}-${warriorTwo.id}`}
                    ownedWarriorIDs={ownedWarriorIDs}
                    isBracket={false}
                  />
                );
              })}
            </Section>
          )}
        </div>
      </div>
    </>
  );
};

const BracketWrapper = () => {
  const router = useRouter();
  const { data: contexts } = useGetContexts({
    enabled: true,
  });
  const [tournamentParam, setTournamentParam] = useState('');

  useEffect(() => {
    if (!router.isReady) return;
    const tournamentParameter = router?.query?.brackets as string;
    const tournamentIDs = Object.keys(TOURNAMENTS);
    if (!tournamentIDs.includes(tournamentParameter)) {
      router.push('/404');
    }
    setTournamentParam(tournamentParameter);
  }, [router, router.isReady, router?.query?.brackets]);

  if (!contexts || !contexts?.context_states.length || !tournamentParam) {
    return <></>;
  }
  const totalStates = contexts.context_states.filter(
    (cont) =>
      cont.context_id === TOURNAMENTS[tournamentParam].apiContext &&
      cont.state !== null
      // cont.state < STATE_NOT_READY
  );
  if (!totalStates.length) {
    router.push('/404');
    return <></>;
  }


  const battleIds = totalStates.map((context) => context.state);
  if (!battleIds || !battleIds.length) {
    router.push('/404');
    return <></>;
  }

  return (

    <BracketComp
      tournamentParam={tournamentParam as TTournamentParams}
      battleIds={battleIds as number[]}
    />
  );
};


export default BracketWrapper;

